"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _Elements = require("../Elements");

var disableLabelOnClick = function disableLabelOnClick(e) {
  e.stopPropagation();
  e.preventDefault();
};

var ErrorMessage = function ErrorMessage(_ref) {
  var id = _ref.id,
      checkboxOffset = _ref.checkboxOffset,
      noSpacing = _ref.noSpacing,
      values = _ref.values,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_Elements.FormErrorMessage, {
    className: "form-error-message ".concat(className),
    onClick: disableLabelOnClick,
    checkboxOffset: checkboxOffset,
    noSpacing: noSpacing && !id
  }, id ? /*#__PURE__*/_react["default"].createElement("span", {
    role: "alert"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: id,
    values: values
  })) : null);
};

ErrorMessage.defaultProps = {
  checkboxOffset: false,
  id: '',
  noSpacing: false,
  values: undefined,
  className: ''
};
ErrorMessage.propTypes = {
  checkboxOffset: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  noSpacing: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  // eslint-disable-next-line react/forbid-prop-types
  values: _propTypes["default"].shape({})
};
var _default = ErrorMessage;
exports["default"] = _default;